import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import InterestModal from '../components/InterestModal';

const PrivacyPolicyPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  useEffect(() => {
    fetchPrivacyPolicy();
  }, []);

  const fetchPrivacyPolicy = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.nisa-care.com/api/v1/privacy-policy');
      const data = await response.json();

      if (data.success) {
        setPolicy(data.data);
      } else {
        setError('Privacy policy not available');
      }
    } catch (err) {
      console.error('Failed to load privacy policy:', err);
      setError('Failed to load privacy policy. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <>
      <Header onShowInterest={handleShowModal} />

      {/* Privacy Policy Section */}
      <section className="privacy-policy-section">
        <div className="container">
          {/* Header */}
          <div className="privacy-header">
            <h1 className="privacy-title">Privacy Policy</h1>
            {policy && (
              <div className="privacy-meta">
                {policy.version && (
                  <span className="privacy-version">Version {policy.version}</span>
                )}
                {policy.updated_at && (
                  <span className="privacy-date">
                    Last updated: {formatDate(policy.updated_at)}
                  </span>
                )}
              </div>
            )}
          </div>

          {/* Loading State */}
          {loading && (
            <div className="privacy-loading">
              <div className="spinner-border text-teal" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3">Loading privacy policy...</p>
            </div>
          )}

          {/* Error State */}
          {error && !loading && (
            <div className="privacy-error">
              <i className="bi bi-exclamation-triangle-fill"></i>
              <h4>Unable to Load Privacy Policy</h4>
              <p>{error}</p>
              <button className="btn-teal" onClick={fetchPrivacyPolicy}>
                <i className="bi bi-arrow-clockwise me-2"></i>
                Try Again
              </button>
            </div>
          )}

          {/* Content */}
          {policy && !loading && !error && (
            <div className="privacy-content-wrapper">
              <div
                className="privacy-content"
                dangerouslySetInnerHTML={{ __html: policy.content }}
              />
            </div>
          )}
        </div>
      </section>

      <Footer />
      <InterestModal show={showModal} handleClose={handleCloseModal} />
    </>
  );
};

export default PrivacyPolicyPage;